<template>
  <div class="select-dict-list">
    <el-table
      ref="dictListTable"
      :data="tableData"
      :row-key="nodeKey"
      size="default"
      style="width: 100%"
      height="100%"
      class="ls-table"
      border
      stripe
      show-overflow-tooltip
      empty-text="暂无数据"
      :header-cell-class-name="cellClass"
      :highlight-current-row="true"
      @row-click="rowClick"
      @select="rowSelect"
    >
      <el-table-column
        :show-overflow-tooltip="false"
        type="selection"
        width="50"
        align="center"
        :selectable="selectable"
        fixed
      />
      <el-table-column label="选项名称" prop="dictItemName"></el-table-column>
      <el-table-column label="选项编码" prop="dictItemCode"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'LSelectDictList',
  props: {
    dict: {
      type: Object,
      default() {
        return null;
      }
    },
    selections: {
      type: Array,
      default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pageData: null,
      tableData: [],
      nodeKey: "dictItemCode"
    }
  },
  watch: {
    dict: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.pageData = newValue;
          this.tableData = this.pageData.items;
        }
      }
    },
  },
  methods: {
    /*单选时将表头的checkbox隐藏*/
    cellClass(row) {
      if (row.columnIndex === 0 && !this.multiple) {
        return "disabledCheck";
      }
    },

    /*设置表格行能否选择*/
    selectable(row) {
      const data = this.selections.find((item) => item[this.nodeKey] === row[this.nodeKey]);
      return !data;
    },

    /*设置表格选中/取消选中*/
    toggleRowSelection(selections, key, flag) {
      selections.map((item) => {
        const result = this.tableData.find((row) => row[key] == item);
        if (result) {
          this.$refs.dictListTable.toggleRowSelection(result, flag);
        }
      });
    },

    /*点击选择框*/
    rowSelect(selection) {
      //单选
      if (!this.multiple) {
        if (selection.length > 1) {
          const del_row = selection.shift();
          this.$refs.dictListTable.toggleRowSelection(del_row, false); //用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
        }
        this.$emit("single");
      }
    },

    /*行点击*/
    rowClick(row) {
      this.$emit("row-click", row);
    },

    /*返回被选中的行*/
    getSelections() {
      return this.$refs.dictListTable.selection;
    }
  }
}
</script>

<style lang="scss" scoped>
.select-dict-list {
  width: 100%;
  height: 100%;

  :deep(.ls-table) {
    .disabledCheck {
      .cell {
        .el-checkbox {
          display: none;
        }
      }
    }

    .el-table__row {
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
